export enum AttributeTypes {
	Text = "Text",
	Color = "Color",
}
